const SERVERLESS_PREFIX = '/_serverless/app-installer-fed-serverless';
export const INSTALLER_TOPOLOGY_API_URL = `${SERVERLESS_PREFIX}/getInstallerTopology`;
export const IDENTITY_TOKEN_VALIDATION_API_URL = `${SERVERLESS_PREFIX}/getIdentityTokenValidation`;
export const getInitialAppInstallationData = _ref => {
  let {
    version,
    appId,
    tenantId,
    languageCode,
    shareUrlId
  } = _ref;
  const urlParams = new URLSearchParams({
    appId,
    ...(version ? {
      version
    } : {}),
    ...(shareUrlId ? {
      shareUrlId
    } : {}),
    tenantId,
    languageCode
  }).toString();
  return `${SERVERLESS_PREFIX}/getAppInstallationData?${urlParams}`;
};
export const getInstallLink = function (_temp) {
  let {
    isShareUrl
  } = _temp === void 0 ? {
    isShareUrl: false
  } : _temp;
  return `${window.location.origin || 'https://www.wix.com'}/_api/site-apps/v1/site-apps/${isShareUrl ? 'install-from-share-url' : 'bulk-install'}`;
};
export const getMetaSiteLink = () => `${window.location.origin || 'https://www.wix.com'}/_api/msm-server/v1/meta-site/get?responseData=namespace
`;
export const getInstallationSourceTokenLink = () => `${SERVERLESS_PREFIX}/installationSourceToken`;
//# sourceMappingURL=apis.js.map